import React from "react"

interface IProps {
  children?: React.ReactNode
}

/**
 * Equips Children with styles to look like a link without beeing one.
 * May be necessary on multiline text to have every single line with a bottom line and
 * not only one line at the end of the block. e.g. when embedded into a <h3>-tag like in ProjectCard:
 * to be seen at a card for projects in the marketplace.
 *
 * Multiline-underline is realized by connecting the looks-like-a-link-className onto a span-tag - without span
 * it would not be multilined. Connection the className to (e.g.) a <h3> directly would not have the multiline effect.
 */
const LinkLookalike: React.FC<IProps> = ({ children }: IProps) => {
  const child = React.Children.only(children) as React.ReactElement<any>

  return <span className="looks-like-a-link">{React.cloneElement(child)}</span>
}

export default LinkLookalike
